// extracted by mini-css-extract-plugin
module.exports = {"root":"PageLayout_root___9ZcJ","pageTitle":"PageLayout_pageTitle__qJW_t"};